import api from './api'
import { toast } from 'react-toastify'

export function findFormulasAtivos(farmaciaId, formulaId) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      const response = await api.get(`farmacias/${farmaciaId}/formulas/${formulaId}/ativos`, {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve(response.data.data);
    } catch (e) {
      toast.error("Erro ao buscar ativos vinculados a fórmula");
      return reject(e);
    }
  })
}

export function linkMultipleAtivoToFormula(farmaciaId, formulaId, ativos) {
  return new Promise(async (resolve, reject) => {
    try {
      const token = localStorage.getItem('FORMULARIO_JSONWEBTOKEN');

      await api.post(`farmacias/${farmaciaId}/formulas/${formulaId}/ativos`, {
        ativos
      }, {
        headers: { authorization: `Bearer ${token}` }
      });

      return resolve();
    } catch (e) {
      toast.error("Falha ao vincular ativos à fórmula");
      return reject(e);
    }
  })
}
